export default "https://assets.egbcdn.net/assets/packs/_/images/app/apk/apk-3-80ec1f219c00cad7e77e839d4afae18f.png";